import React from 'react'
import { NavLink } from 'react-router-dom'
import { SocialIcon } from 'react-social-icons'

const NavBar = () => {
	return (
		<>
			<header className='bg-primary-900'>
				<div className='container mx-auto flex justify-between'>
					<div className='flex justify-between'>
						<NavLink
							to='/'
							exact
							activeClassName='bg-secondary-900'
							className='inline-flex items-center cursive px-2 py-3 pb-4 text-2xl sm:text-4xl text-secondary-600'>
							Sara Gray
						</NavLink>
					</div>
					<div className='sm:mt-2'>
						<NavLink
							to='/projects'
							activeClassName='bg-primary-700 font-bold'
							className='inline-flex items-center px-2 sm:px-4 py-2 my-2 rounded text-primary-200 hover:text-secondary-600'>
							Projects
						</NavLink>
						<NavLink
							to='/about'
							activeClassName='bg-primary-700 font-bold'
							className='inline-flex items-center px-2 sm:px-4 py-2 my-2 rounded text-primary-200 hover:text-secondary-600'>
							About
						</NavLink>
						<NavLink
							to='/post'
							activeClassName='bg-primary-700 font-bold'
							className='inline-flex items-center px-2 sm:px-4 py-2 my-2 mr-1 rounded text-primary-200 hover:text-secondary-600'>
							Posts
						</NavLink>
					</div>
					<div className='hidden sm:inline-flex sm:mt-6 px-3'>
						<SocialIcon
							url='https://twitter.com/saragrayen'
							className='mr-2'
							target='_blank'
							fgColor='#fff'
							style={{ height: 25, width: 25 }}
						/>
						<SocialIcon
							url='https://github.com/sara-gray'
							className='mr-2'
							target='_blank'
							fgColor='#fff'
							bgColor='#000'
							style={{ height: 25, width: 25 }}
						/>
						<SocialIcon
							url='https://www.linkedin.com/in/saragrayen/'
							className='mr-2'
							target='_blank'
							fgColor='#fff'
							style={{ height: 25, width: 25 }}
						/>
					</div>
				</div>
			</header>

			<div className='sm:hidden fixed top-32 right-1 z-40 flex flex-col bg-transparent'>
				<SocialIcon
					url='https://twitter.com/saragrayen'
					className='mb-4'
					target='_blank'
					fgColor='#fff'
					style={{ height: 35, width: 35 }}
				/>
				<SocialIcon
					url='https://github.com/sara-gray'
					className='mb-4'
					target='_blank'
					fgColor='#fff'
					bgColor='#000'
					style={{ height: 35, width: 35 }}
				/>
				<SocialIcon
					url='https://www.linkedin.com/in/saragrayen/'
					target='_blank'
					fgColor='#fff'
					style={{ height: 35, width: 35 }}
				/>
			</div>
		</>
	)
}

export default NavBar
